<template>
  <div>
    <div class="row">
      <div class="col-md-8 offset-md-2 col-sm-12">
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  Mail
                </h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">

            <div class="form-group">
              <label>Subject</label>
              <input type="text" class="form-control" v-model="subject">
            </div>
            <div class="form-group">
              <label>Body</label>
              <textarea class="form-control" cols="30" rows="10" v-model="body"></textarea>
            </div>
            <div class="form-group">
              <button class="btn btn-success" @click="save" :disabled="saving">Save</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    created() {
      this.axios.get('options').then(response => {
        this.subject = response.data.data.subject
        this.body = response.data.data.body
      })
    },
    data() {
      return {
        subject: null,
        body: null,
        saving: false,
      }
    },
    methods: {
      save() {
        this.axios.post('options', {options: {subject: this.subject, body: this.body}}).then(() => {
          this.$awn.success('Saved.')
        }).finally(() => {
          this.saving = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/emails/Index.vue